
<div class="v-flex step-title" style="margin-bottom: 8px;">
    <div class=" primary--text" >
        {{ title }}
    </div>
    <div>
        <slot name="right"></slot>
    </div>
</div>
